module.exports = __webpack_public_path__ + "static/img/yellow.f59c6bbc.png";